export default {
    priKey:'d6231ff6a68cf6df28c56f3e0ba5723d'
}



// WEBPACK FOOTER //
// ./src/service/constant/privateKey.js